<script setup lang="ts">
import { usePageContext } from '@/composables/usePageContext'
import AppNavigation from '@/ui-kit/layout/AppNavigation.vue'
import VPurchaseStatus from '@/ui-kit/components/PurchaseStatus/PurchaseStatus.vue'

interface PurchaseButton {
  buttonType: 'purchase' | 'view' | 'pay' | 'custom'
  buttonText: string
  buttonLink: string
}

interface PurchaseDiscount {
  base_price: number
  discount_percent: number
  reason?: string
}

interface PurchaseStatus {
  lock_reason: string
  price: number | null
  status_code: string
  button: PurchaseButton | null
  discount: PurchaseDiscount | null
}

interface AttestationDescriptionContext {
  acecourse_name: string
  purchase_url: string
  purchase_status: PurchaseStatus
  description_html: string
}

const ctx = usePageContext<AttestationDescriptionContext>()
</script>

<template>
  <div class="account-frame">
    <AppNavigation role="teacher" rules-url="/website/documents/oferta" />

    <div class="content">
      <div class="header">О курсе АС</div>
      <div class="title">{{ ctx.acecourse_name }}</div>

      <VPurchaseStatus
        :purchase-url="ctx.purchase_url"
        :lock-reason="ctx.purchase_status.lock_reason"
        :price="ctx.purchase_status.price"
        :status-code="ctx.purchase_status.status_code"
        :button="ctx.purchase_status.button"
        :discount="ctx.purchase_status.discount"
      />

      <div class="text" v-html="ctx.description_html" />

      <VPurchaseStatus
        secondary
        :purchase-url="ctx.purchase_url"
        :lock-reason="ctx.purchase_status.lock_reason"
        :price="ctx.purchase_status.price"
        :status-code="ctx.purchase_status.status_code"
        :button="ctx.purchase_status.button"
        :discount="ctx.purchase_status.discount"
      />
    </div>
  </div>
</template>

<style lang="scss">
.text iframe {
  max-width: 100%;
}
</style>
